import { React, useEffect, useState, CustomModal, CustomTable, Toast, Breadcrumb, Card, _formatDate, Icon } from '../utils/commonImports';
import { _api } from '../auth/Api';
import { Alert, DatePicker } from "antd";
import Select from "react-select";
import dayjs from "dayjs";
import { customStyleMd } from "../utils/common";
import { _exportToExcel } from "../helper/ExportToExcel";

const Dealerships = () => {
  const [dealers, setDealers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState({ isOpne: false, data: {} });
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showExp, setShowExp] = useState(false);
  const [filterBtnShow, setFilterBtnShow] = useState(true);
  const [citiesDrp, setCitiesDrp] = useState([]);
  // Pagenation
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filters, setFilters] = useState({
    dealerName: "",
    ntnDealer: "",
    code: "",
    phone: "",
    region: "",
    cityId: null,
    createDateto: null,
    createDateFrom: null
  });

  useEffect(() => {
    _getDealers();
    _getCities();
  }, []);

  const _getCities = async () => {
    try {
      await _api("GET", "Cities/GetCities?CityId=0", null, (res) => {
        if (res.isSuccess) {
          const drp = res.data?.map((x) => ({
            value: x.cityId,
            label: x.cityName,
          }));
          setCitiesDrp(drp)
        }
      })
    } catch (error) {
      console.log("API Error", error?.message)
    }
  }

  const _getDealers = async (filterValues = {}, pageNo = page, numberOfRecords = pageSize) => {
    const payload = {
      dealerName: filterValues.dealerName || "",
      phone: filterValues.phone || "",
      cityId: filterValues.cityId?.value || null,
      region: filterValues.region || "",
      code: filterValues.code || "",
      ntnDealer: filterValues.ntnDealer || "",
      createdDateTo: filterValues.createDateto ? dayjs(filterValues.createDateto).format("YYYY-MM-DD") : "",
      createdDateFrom: filterValues.createDateFrom ? dayjs(filterValues.createDateFrom).format("YYYY-MM-DD") : "",
      page: {
        pageNo: pageNo,
        numberOfRecords: numberOfRecords,
      },
    };

    try {
      setLoading(true);
      await _api("POST", "Dealer/GetAllDealer", payload, (res) => {
        if (res.isSuccess) {
          setDealers(res.data);
          setTotalRecords(res.totalRecords || 0);
        } else {
          setDealers([]);
          //Toast.fire({ icon: "error", title: res.message });
        }
        setLoading(false);
      });
    } catch (error) {
      console.error(error);
      setDealers([]);
      setLoading(false);
      Toast.fire({ icon: "error", title: "Failed to fetch dealers" });
    }
  };

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
    _getDealers(filters, pagination.current, pagination.pageSize);
  };

  const handleReset = () => {
    let filter = { dealerName: "", cityId: null, region: "", code: "", ntnDealer: "", phone: "", createDateto: null, createDateFrom: null, }
    setFilters(filter);
    setShowExp(false);
    _getDealers(filter, 1, pageSize);
  };

  const handleApply = () => {
    const { dealerName, cityId, region, code, phone, ntnDealer, createDateto, createDateFrom } = filters;
    if (!dealerName && !cityId && !region && !code && !phone && !ntnDealer && !createDateto && !createDateFrom) {
      setShowExp(true);
      return;
    }
    setPage(1);
    _getDealers(filters, 1, pageSize);
  };

  const launchDetailModal = (type, record) => {
    setIsModalOpen({ isOpne: type, data: record });
  };

  const columns = [
    {
      title: "Dealer",
      dataIndex: "dealerName",
      render: (name, record) => (
        <div className="d-flex align-items-center gap-2">
          <div>
            <div className="">{name}</div>
            <div className="text-muted small">{record.dealerShortName}</div>
          </div>
        </div>
      ),
    },
    {
      title: "Contact Info",
      dataIndex: "email",
      render: (email, record) => (
        <div>
          <div className="small">{email}</div>
          <div className="text-muted small">{record.phone}</div>
        </div>
      ),
    },
    {
      title: "Code & NTN",
      dataIndex: "code",
      render: (code, record) => (
        <div>
          <div className="small">{code}</div>
          <div className="text-muted small">{record.ntnDealer}</div>
        </div>
      ),
    },
    {
      title: "Location",
      dataIndex: "address",
      render: (address, record) => (
        <div>
          <div className="small">{address}</div>
          <div className="text-muted small">{record.region}</div>
        </div>
      ),
    },
    {
      title: "Created On",
      dataIndex: "createDate",
      render: (createDate) => _formatDate(createDate)
    },
  ];

  const xlsColumns = [
    { title: "Dealer Id", dataIndex: "dealerId" },
    { title: "Code", dataIndex: "code" },
    { title: "Name", dataIndex: "dealerName" },
    { title: "Email", dataIndex: "email" },
    { title: "Phone", dataIndex: "phone" },
    { title: "Address", dataIndex: "address" },
    { title: "Region", dataIndex: "region" },
    { title: "NTN No", dataIndex: "ntnDealer" },
    { title: "Longitude", dataIndex: "longitude" },
    { title: "Latitude", dataIndex: "latitude" },
    { title: "Created On", dataIndex: "createDate" },
    //{ title: "Status", dataIndex: "status" },
  ]
  const handleExport = async () => {
    setBtnLoading(true);

    const payload = {
      dealerName: "",
      phone: "",
      cityId: null,
      region: "",
      code: "",
      ntnDealer: "",
      createDate: "",
      page: {
        pageNo: 0,
        numberOfRecords: 0,
      },
    };

    try {
      await _api("POST", "Dealer/GetAllDealer", payload, (res) => {
        if (res.isSuccess) {
          const krDateSahe = res.data.map((x) => ({
            ...x,
            createDate: _formatDate(x.createDate),
          }));

          setTimeout(() => {
            _exportToExcel({
              data: krDateSahe,
              columns: xlsColumns,
              fileName: "MCML Dealers",
            });
            setBtnLoading(false);
          }, 1500);
        } else {
          setBtnLoading(false);
        }
      });
    } catch (error) {
      console.error(error);
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Dealers Management" />
      {filterBtnShow && (
        <Card className='mb-3'>
          <div className="p-2 bg-white">
            <div className="row g-2">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Dealer Name"
                  value={filters.dealerName}
                  onChange={(e) =>
                    setFilters({ ...filters, dealerName: e.target.value })
                  }
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Dealer Code"
                  value={filters.code}
                  onChange={(e) => setFilters({ ...filters, code: e.target.value })}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="NTN Dealer"
                  value={filters.ntnDealer}
                  onChange={(e) =>
                    setFilters({ ...filters, ntnDealer: e.target.value })
                  }
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Dealer Phone No"
                  value={filters.phone}
                  onChange={(e) =>
                    setFilters({ ...filters, phone: e.target.value })
                  }
                />
              </div>

              <div className="col-md-3">
                <Select
                  options={citiesDrp}
                  value={filters.cityId}
                  onChange={(val) => setFilters({ ...filters, cityId: val })}
                  placeholder="Select City"
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              {/* <div className="col-md-3 d-none">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Region"
                  value={filters.region}
                  onChange={(e) =>
                    setFilters({ ...filters, region: e.target.value })
                  }
                />
              </div> */}

              <div className="col-md-3">
                <Select
                  options={[
                    { label: "Sindh", value: "Sindh" },
                    { label: "Punjab", value: "Punjab" },
                    { label: "Balochistan", value: "Balochistan" },
                    { label: "khyber Pakhtunkhwa KP", value: "KP" }
                  ]}
                  //value={vehiclesDrp.find(opt => opt.label === filters.vehicleName) || null}
                  onChange={(val) => setFilters({ ...filters, region: val?.label || "" })}
                  placeholder="Select Region"
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.createDateFrom ? dayjs(filters.createDateFrom) : null}
                  onChange={(date) => setFilters({ ...filters, createDateFrom: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (current && current > dayjs().endOf("day")) return true;
                    if (filters.createDateto && current > dayjs(filters.createDateto)) return true;
                    return false;
                  }}
                  placeholder="Created Date (From)"
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.createDateto ? dayjs(filters.createDateto) : null}
                  onChange={(date) => setFilters({ ...filters, createDateto: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (current && current > dayjs().endOf("day")) return true;
                    if (filters.createDateFrom && current < dayjs(filters.createDateFrom)) return true;
                    return false;
                  }}
                  // disabled={!filters.createDateFrom}
                  placeholder="Created Date (To)"
                />
              </div>

            </div>

            <div className="d-flex align-items-center justify-content-between gap-2 mt-3">
              <div className="flex-grow-1">
                {showExp && (
                  <Alert
                    showIcon
                    message="NOTE: Please fill at least one filter"
                    type="warning"
                  />
                )}
              </div>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setFilterBtnShow(false)}
                >
                  Hide Filter
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={handleReset}
                >
                  Reset Filter
                </button>
                <button className="btn btn-sm btn-primary" onClick={handleApply}>
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        </Card>
      )}

      <Card>
        <div className="d-flex justify-content-end gap-2" style={{ marginBottom: "10px" }}>
          {!filterBtnShow && (
            <button
              onClick={() => setFilterBtnShow(true)}
              className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
              style={{ lineHeight: '1.2' }}
            >
              Filter Dealers
              <Icon icon="mdi:filter-cog-outline" className="text-md" />
            </button>
          )}
          <button
            onClick={handleExport}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
            disabled={btnLoading}
          >
            {btnLoading && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {btnLoading ? "Exporting..." : "Export to Excel"}
            <Icon icon="mdi:microsoft-excel" className="text-md" />
          </button>
        </div>
        <CustomTable
          columns={columns}
          dataSource={dealers}
          options={{
            withActions: true,
            loading: loading,
            bordered: true,
            showView: true,
            showEdit: false,
            showDelete: false,
            size: "small",
            rowKey: "dealerId",
            emptyText: "No dealers found",
            pageKey: 4
          }}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            currentLength: dealers.length
          }}
          onChange={handleTableChange}
          onView={(record) => launchDetailModal(true, record)}
        />
      </Card>

      <CustomModal
        title="Dealer Details"
        show={isModalOpen.isOpne}
        size="lg"
        onHide={() => launchDetailModal(false, {})}
      >
        {isModalOpen.data && (
          <div className="row g-3">
            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Dealer Name:</small>
                <div className="fw-semibold text-sm">
                  {isModalOpen.data?.dealerName}
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Short Name:</small>
                <div className="fw-semibold text-sm">
                  {isModalOpen.data?.dealerShortName}
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Status:</small>
                <div>
                  <span
                    className={`badge ${isModalOpen.data?.isActive ? "bg-success" : "bg-danger"
                      }`}
                  >
                    {isModalOpen.data?.isActive ? "Active" : "Inactive"}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Email:</small>
                <div className="fw-semibold text-sm">
                  {isModalOpen.data?.email}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Phone:</small>
                <div className="fw-semibold text-sm">
                  {isModalOpen.data?.phone}
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="border rounded p-3 bg-light shadow-sm">
                <small className="text-muted d-block mb-2">Address:</small>
                <div className="fw-semibold">{isModalOpen.data?.address}</div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Region:</small>
                <div className="fw-semibold text-sm">
                  {isModalOpen.data?.region}
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Latitude:</small>
                <div className="fw-semibold text-sm">
                  {isModalOpen.data?.latitude}
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Longitude:</small>
                <div className="fw-semibold text-sm">
                  {isModalOpen.data?.longitude}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Service Frequency:</small>
                <div className="fw-semibold text-sm">
                  Every {isModalOpen.data?.serviceInterval} days
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Registered On:</small>
                <div className="fw-semibold text-sm">
                  {_formatDate(isModalOpen.data?.createDate)}
                </div>
              </div>
            </div>
          </div>
        )}
      </CustomModal>
    </>

  );
};

export default Dealerships;